import Currency from "../../components/currency/Currency"

function CurrencyPage() {
    return (
        <>
            <Currency />
        </>
    )
}
export default CurrencyPage